import { BillDetailTypes, SuccessFetch } from "../types/billAdjustmentTypes"
import { useApi } from "utils"
import { adjustmentFreightStore } from "./adjustmentFreightStore"


export function useBillDetail(id:string) {
    const {
        data_bill,
        setDataBill,
        setLoading,
        setTotalDetail,
        setSaldo,
    } = adjustmentFreightStore()

    const api = useApi()
    
    const fetchData = () => {
        setLoading(true)
        const params = {
            bill_id: id,
        }

        api.get("/probill/get_freight_adjustment_by_id", { params })
        .then((res) => {
            const response: SuccessFetch<BillDetailTypes[]> = res.data;
            let data = response.payload;
            setDataBill(data[0])
            const totalDetail = Number(data[0].freight) + Number(data[0].total_bill) + Number(data[0].total_tax)
            const totalSaldo = totalDetail -  Number(data[0].tot_payment)
            setTotalDetail(totalDetail)
            setSaldo(totalSaldo)
        })
        .catch(() => {
            setDataBill(data_bill);
        })
        .finally(() => setLoading(false))
    }

    return{
        fetchData,
    }

}